<template>
    <v-app id="app" :dark="false">
        <NotificationCenter />
        <GenericInputDialogFromAction />
        <OkCancelDialogFromAction />
        <ProgressComponent />
        <ButtonSelectionDialogFromAction />
        <EditHeader class="titlebar" />
        <TableEditor class="editor"
                        v-if="dataAvailable"
                        id="tableEditor"
                        v-on:currentScrollPosition="currentScrollPositionChange"
                        :initialScrollPosition="tableScrollPosition" />
        <div v-else class="editor"></div>
        <SettingsEditor />
        <InfoComponent />
        <EditFooter class="footer" />
    </v-app>
</template>

<script>
    import EditHeader from "./EditHeader.vue";
    import EditFooter from "./EditFooter.vue";
    import TableEditor from "./TableEditor/TableEditor.vue";
    import SettingsEditor from "./SettingsEditor.vue";
    import NotificationCenter from "./NotificationCenter.vue";
    import OkCancelDialogFromAction from "./helpers/OkCancelDialogFromAction.vue";
    import GenericInputDialogFromAction from "./helpers/GenericInputDialogFromAction.vue";
    import ButtonSelectionDialogFromAction from "./helpers/ButtonSelectionDialogFromAction.vue";
    import ProgressComponent from "./helpers/ProgressComponent.vue";
    import InfoComponent from "./InfoComponent.vue";
    import { notificationMixin } from "../mixins/notificationMixin.js";
    import { LOAD_FILE } from "../../store/modules/uptData/constants.js";
    import { SET_REDIRECT_AFTER_SAVE } from "../../store/modules/settings/constants.js";
    import eventBus from "../utils/eventBus";

    const _ = require("lodash");

    export default {
        name: "app",
        mixins: [notificationMixin],
        data: () => ({
            needUpdate: false,
            tableScrollPosition: null
        }),
        computed: {
            dataAvailable() {
                return this.$store.state.uptData.dataAvailable && !this.needUpdate;
            }
        },
        created: async function () {
            await this.editSpecificFile();
            eventBus.$on("fullUpdate", args => this.update(args));
        },
        beforeDestroy: function () {
            eventBus.$off("fullUpdate", args => this.update(args));
        },
        components: {
            EditHeader,
            EditFooter,
            TableEditor,
            SettingsEditor,
            NotificationCenter,
            OkCancelDialogFromAction,
            GenericInputDialogFromAction,
            ButtonSelectionDialogFromAction,
            ProgressComponent,
            InfoComponent
        },
        methods: {
            async editSpecificFile() {
                const filename = _.get(this.$route.query, "filename", false);
                const customerId = _.get(this.$route.query, "customer_id", false);
                const redirectUrl = _.get(this.$route.query, "redirect_url", false);
                if (filename && customerId && redirectUrl) {
                    this.$store.dispatch(SET_REDIRECT_AFTER_SAVE, {
                        filename,
                        customerId,
                        redirectUrl
                    });
                    await this.$store.dispatch(LOAD_FILE, {
                        path: filename,
                        specificCustomerId: customerId
                    });
                }
            },
            update(args) {
                if (!_.get(args, "retainScrollPosition")) {
                    this.tableScrollPosition = 0;
                }
                this.needUpdate = true;
                this.$nextTick(() => (this.needUpdate = false));
            },
            currentScrollPositionChange(pos) {
                this.tableScrollPosition = pos;
            }
        }
    };
</script>

<style></style>
